export const VAPID_KEY = 'BKP6Mrf58Ke7wUIXsSmqCHwYePRDXXPGU4qkp4IDP5dRMbm1QMO9QDUdrTOE3ZJfkV4PNPH1yhfG54JCw6kTbzw'

export const SUFFIX_SEARCH = '_searchValue'
